import React, { useEffect, useRef } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActivityLoader from '../../components/Common/ActivityLoader';
import Notification from '../../components/Common/Notification';
import Pagination from '../../components/Common/Pagination';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import printContent from '../../util/araknerdlib';
import { useStaff } from '../../DataStore/StaffContext';
import functions from '../../util/functions';

const StaffListingPage = () => {
    const { listing, metaData, setCurrentPage, getStaffMembers, mounted } = useStaff();
    const reportRef = useRef();

    useEffect(() => {
        if(!mounted){
            getStaffMembers();
        }
    }, []);

    const PageActions = () => (
        <>
            <ActionDropdownItem iconClass="fa fa-calendar text-success" label="Filter Class" />
            <ActionDropdownItem iconClass="fa fa-sync text-primary" label="Refresh" onClick={() => getStaffMembers(true)} />
            <ActionDropdownItem iconClass="fa fa-print text-secondary" label="Print" onClick={() => printContent(reportRef, "Staff List")} />
        </>
    );

    return (
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Staff Listing"
                    description="View and manage staff"
                    iconClass="fa fa-users"
                    sticky={true}
                    PageActions={PageActions}
                    Pagination={metaData ? (
                        <Pagination
                            metaData={metaData}
                            onPageChange={(page) => setCurrentPage(page)}
                            loadMore={true}
                        />
                    ) : null}
                />

                <div ref={reportRef}>
                    <div className="card mb-4">
                        <div className="card-body">
                            {Array.isArray(listing) ? (
                                <table className="table table-striped table-bordered">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>#</th>
                                            <th>Reg. No</th>
                                            <th>Full Name</th>
                                            <th>Initials</th>
                                            <th>Gender</th>
                                            <th>Reg Date</th>
                                            <th>Work Contact</th>
                                            <th>Home Contact</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listing.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td>{item.reg_no}</td>
                                                <td>{`${item.full_name} ${item.prefix.prefix ? '(' + item.prefix.prefix + ')' : ''}`}</td>
                                                <td>{item.initials}</td>
                                                <td>{item.gender}</td>
                                                <td>{item.registration_date ? functions.formatDate(item.registration_date) : ''}</td>
                                                <td>{item.work_contact}</td>
                                                <td>{item.home_contact}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : listing === '404' ? (
                                <Notification type="info" message="No students found." closable={false} />
                            ) : (
                                <ActivityLoader />
                            )}
                        </div>
                    </div>
                </div>
            </MainContent>
        </PageContainer>
    );
};

export default StaffListingPage;
